import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { icon, label } from "../../config";
import { useCombinationKeys } from "../../helper/commonHooks";
import "./overallSearch.scss";
import OverallSearchPopup from "./OverallSearchPopup";
import { useResetContextSearchOnScopeChange } from "./useResetContextSearchOnScopeChange";

const OverallSearch = (props) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const ctrlF = useCombinationKeys("f");
  const location = useLocation();
  const globalContextSearch = useSelector((state) => state?.allProjects?.contextSearch ?? "");
  useResetContextSearchOnScopeChange();

  /**
   * This effect listens for a Ctrl+F trigger and displays a custom popup, unless the user is on a CMS-related page.
   * @author Abhishek Dhillon
   */
  useEffect(() => {
    if (ctrlF) {
      setShowPopup(true);
    }
  }, [ctrlF]);

  return (
    <>
      <div className='overall-search-container' onMouseEnter={() => setShowControls(true)} onMouseLeave={() => setShowControls(false)}>
        <div className='position-relative d-none d-lg-block' onClick={() => setShowPopup(true)}>
          <span className='overall-search-icon position-absolute opacity-50 cursor-pointer'>{icon.SEARCH}</span>
          <input
            title={label.OVERALL_SEARCH_INPUT_TITLE}
            type='text'
            className='form-control search-input'
            placeholder='Find'
            autoComplete='off'
            onFocus={() => setShowPopup(true)}
            value={globalContextSearch}
          />
          <div className={`overall-search-controls position-absolute ${showControls ? "d-flex" : "d-none"} align-items-center`}>
            <span className='alt-key-container cursor-pointer d-inline-block px-2 py-1'>{label.CTRL_F}</span>
          </div>
        </div>

        <div type='button' className='d-inline-block d-lg-none ms-2 dropdown'>
          <button className='btn header-item header-icon header-hover-btn' onClick={() => setShowPopup(true)}>
            {icon.SEARCH}
          </button>
        </div>
        {showPopup && (
          <OverallSearchPopup
            anchor={props.anchor}
            relationStatus={props.relationStatus}
            setShowPopup={setShowPopup}
            entityName={props.entityName}
            popupClass={props.popupClass}
          />
        )}
      </div>
    </>
  );
};

export default OverallSearch;
